module.exports = __webpack_public_path__ + "img/project-back-night.ae2d7065.svg";